import type SecretEncryptionRepository from "@/core/administration/repositories/SecretEncryptionRepository";
import type { EncryptedSecret } from "@/core/administration/entities/SecretEncryption";
import { RepositoryResult } from "@/core/shared/types/RepositoryResult";
import { HttpClient } from "../../http/HttpClient";
import { ApiResponse } from "../../api/types/ApiResponse";
import { executeRequest } from "../../http/services/executeRequest/executeRequest";
import secretEncryptionEndpoints from "../../api/secretEncryptionEndpoints/secretEncryptionEndpoints";

type EncryptedSecretDto = {
  encrypted: string;
};

export default class SecretEncryptionRepositoryBackend
  implements SecretEncryptionRepository
{
  constructor(private readonly httpClient: HttpClient) {}

  encrypt(value: string): Promise<RepositoryResult<EncryptedSecret>> {
    return executeRequest(
      () =>
        this.httpClient.post<ApiResponse<EncryptedSecretDto>, { value: string }>({
          url: secretEncryptionEndpoints.encrypt(),
          body: { value },
          withAuth: true,
        }),
      (dto) => ({ encrypted: dto.encrypted }),
    );
  }
}
